import { Component, OnInit } from '@angular/core';
import { PurchaseService } from '../../../purchase/services/purchase.service';
import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { ProductService } from '../../../products/services/product.service';
import { UserService } from '../../../common/services/user.service';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-purchases',
  templateUrl: './list-purchases.component.html',
  styleUrls: ['./list-purchases.component.css'],
  providers:[PurchaseService,PurchaseProductService,ProductService,UserService]
})
export class ListPurchasesComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  purchases:any = [];
  filters:any = {
    barcode:{contains: ""},
    nif: {contains: ""},
    name: {contains: ""},
    surname: {contains: ""},
    total_amount: {contains: ""}
  };
  productFilter:any = {
    brand:{contains: ""},
    model: {contains: ""},
    storage_capacity: {contains: ""},
    serial_number: {contains: ""},
    description: {contains: ""},
    imei:{contains: ""}
  };
  exportParams:any ={};
  showExportButton:boolean = true;
  from:any;
  until:any;
  role:number = 3;
  users:any = [];

  constructor(private purchaseService: PurchaseService, private productService: ProductService, private userService:UserService, 
    private purchaseProductService:PurchaseProductService) { }

  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
      if (location.href.split('?')[1]){
        this.filters = JSON.parse(localStorage.getItem('purchase-filter'));
        this.productFilter = JSON.parse(localStorage.getItem('purchase-filter-product'));  
        this.getFilters();
      }else{
        this.getPurchases(null);
        this.getPurchasesProducts();
      }
      if (this.role === 1){
        this.getUsers();
      }
    }catch(e){
      this.getPurchases(null);
      this.getPurchasesProducts();
    }
  }

  getUsers(){
    this.userService.query({})
        .subscribe((users) => {
            this.users = users;
            this.users.unshift({id:null, username:"Ninguno"});
        });
  }

  getFilters(){
    localStorage.setItem('purchase-filter',JSON.stringify(this.filters));
    localStorage.setItem('purchase-filter-product',JSON.stringify(this.productFilter));
    location.href = location.href.split('?')[0]+"?filters=true";
    if (this.filters && this.filters.createdBy == null){
      delete this.filters.createdBy;
    }
    if (this.productFilter.brand.contains != "" || this.productFilter.model.contains != "" || this.productFilter.storage_capacity.contains != "" ||
        this.productFilter.serial_number.contains != "" || this.productFilter.description.contains != "" || this.productFilter.imei.contains != ""){
          this.getPurchasesByProducts();
    }else{
      this.getPurchases(null);
    }
  }

  getPurchasesByProducts(){
    let params = {
      where: _.cloneDeep(this.productFilter)
    };
    this.productService.query(params)
      .subscribe((products) => {
        var purchases = _.compact(products.map(e => e.purchaseProduct[0]?e.purchaseProduct[0].purchase:null));
        if (purchases.length > 0){ 
          this.getPurchases(purchases);
        }else{
          this.purchases = [];
        }
      });
  }

  getPurchases(prefilter){
    let params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (prefilter && !params.where.id){
      params.where.id = prefilter;
    }
    if (params.where.id == ""){
      delete params.where.id
    }
    if (this.from && moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.until && moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    this.exportParams = params;
    this.purchaseService.query(params)
               .subscribe((purchases) => {
                  let countParams = {
                    where: _.cloneDeep(params.where),
                  };
                  this.purchaseService.count(countParams)
                  .subscribe((count) => {
                    this.totalItems = count.count;
                  });
                  this.purchases = purchases;
                  this.getPurchasesProducts();
                });
    }

    getPurchasesProducts(){
      let params = {
        where: {
          purchase_id: this.purchases.map(e => e.id)
        }
      }
      this.purchaseProductService.query(params)
      .subscribe((purchaseProducts) => {
         let groupedPurchaseProducts = _.groupBy(purchaseProducts, (element)=> {return element.purchase.id})
         this.purchases.forEach( (p) =>{
           if (groupedPurchaseProducts[p.id] && groupedPurchaseProducts[p.id].length > 0){
            this.parseProductsDescription(p, groupedPurchaseProducts[p.id]);
           }
         });
       });
    }

    parseProductsDescription(element, groupedProducts){
      element.productDescription = "";
      groupedProducts.forEach(products=>{
        if ((products.product.type!="1" && products.product.type!="4") || ((products.product.type=="1" || products.product.type=="4") && !products.product.sub_type)){
          element.productDescription += this.getNameProductType(products.product.type)+"- ";
        }
       if ((products.product.type=="1" || products.product.type=="4") && products.product.sub_type){
          element.productDescription += this.getNameSubType(products.product.sub_type,products.product.type)+"- ";
        }
        if (products.product.brand){
          element.productDescription += "Marca:"+products.product.brand+", ";
        }
        if (products.product.model){
          element.productDescription += "Modelo:"+products.product.model+", ";
        }
        if (products.product.telephone_company){
          element.productDescription += "Compañia:"+products.product.telephone_company+", ";
        }
        if (products.product.storage_capacity){
          element.productDescription += "Capacidad:"+products.product.storage_capacity+", ";
        }
        if (products.product.status){
          element.productDescription += "Estado:"+products.product.status+", ";
        }
        if (products.product.imei){
          element.productDescription += "Imei:"+products.product.imei+", ";
        }
        if (products.product.imei2){
          element.productDescription += "Imei2:"+products.product.imei2+", ";
        }
        if (products.product.serial_number){
          element.productDescription += "Número de serie:"+products.product.serial_number+", ";
        }
        if (products.product.so){
          element.productDescription += "Sistema Operativo:"+products.product.so+", ";
        }
        if (products.product.ram){
          element.productDescription += "Ram:"+products.product.ram+", ";
        }
        if (products.product.description){
          element.productDescription += "Descripción:"+products.product.description+", ";
        }
        element.productDescription = element.productDescription .slice(0, -2) + " / ";
      });
    }
  
    getNameProductType(type){
      var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
      return productType[type-1];
    }
  
    getNameSubType(subType, type){
      let subTypes = ["",""];  
      if (type == 1){
        subTypes =["Móvil","Tablet"];
      }else if (type == 4){
        subTypes =["PC","Portatil"];
      }
      return subTypes[subType-1];
    }

    delete(id){
      var r = confirm("¿Esta seguro de borrar esta compra?");
      if (r == true) {
        let params = {
          where: {
            purchase_id: id
          }
        }
        this.purchaseProductService.query(params)
        .subscribe((purchaseProducts) => {
          purchaseProducts.forEach((e)=>{
            this.productService.delete(e.product.id).subscribe(()=>{});
            this.purchaseProductService.delete(e.id).subscribe(()=>{});
          });
        });
        this.purchaseService.delete(id).subscribe(()=>{
          this.getPurchases(null);
        });
      }
    }


    exportPurchasesToExcel(){
      this.showExportButton = false;
      var options = {   
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          showTitle: false,
          useBom: false,   
          bookType:'xlsx' ,  
          cellStyles:true,
      };             
      let report = [
            {
                field1:"Nº de compra",
                field2:"Fecha",
                field3:"NIF Cliente",
                field4:"Cliente",
                field5:"Artículos",
                field6:"Total",
                field7:"Método de pago",
                field8:"Estado",
                
            }
        ]
        delete this.exportParams.skip;
        delete this.exportParams.limit;
        let observablePurchasesRequest = [];
        let request = Math.ceil(this.totalItems / 100);
        for (let i=0; i<request;i++){
          this.exportParams.skip = ((i)*100),
          this.exportParams.limit = 100;
          observablePurchasesRequest.push(this.purchaseService.query(this.exportParams));
        }
        Observable.forkJoin(observablePurchasesRequest)
            .subscribe(data => {
              let p:any = data;
              let purchases = p.flat(); 
              let params = {
                where: {
                  purchase_id: purchases.map(e => e.id)
                }
              }
              this.purchaseProductService.query(params)
              .subscribe((purchaseProducts) => {
                let groupedPurchaseProducts = _.groupBy(purchaseProducts, (element)=> {return element.purchase.id});
                purchases.forEach( (p) =>{
                  if (groupedPurchaseProducts[p.id] && groupedPurchaseProducts[p.id].length > 0){
                   this.parseProductsDescription(p, groupedPurchaseProducts[p.id]);
                  }
                });

                purchases.forEach(purchase =>{
                      var row = {
                          field1:purchase.id?purchase.id:"",
                          field2:purchase.date?moment(purchase.date).format("DD-MM-YYYY"):"",
                          field3:purchase.nif ?purchase.nif:"",
                          field4:purchase.name || purchase.surname?purchase.name +" "+ purchase.surname:"",
                          field5:purchase.productDescription?purchase.productDescription:"",
                          field6:purchase.total_amount?purchase.total_amount:"",
                          field7:purchase.method_of_payment?purchase.method_of_payment:"",
                          field8:purchase.status?purchase.status:"",
                      }
                      report.push(row);
                  });
                  var mystyle = {   
                      headers:true,       
                      columns:    
                          [{columnid:'field1',width:100,title: ''},   
                          {columnid:'field2',width:100,title: ''},
                          {columnid:'field3',width:100,title: 'LISTADO DE COMPRAS'},
                          {columnid:'field4',width:100,title: ''},
                          {columnid:'field5',width:300,title: ''},
                          {columnid:'field6',width:100,title: ''},
                          {columnid:'field7',width:100,title: ''},
                          {columnid:'field8',width:100,title: ''},
                          
                          ],
                      /*header*/
                    
                      column: {  
                          style:{
                              Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",  
                                  WrapText:1
                                  
                              },
                              Font:{
                                  Bold:"1",
                                  Color:"#000000",
                                  Size:10
                              },
                              
                              Interior:{
                                  Color:"#7CEECE",
                                  Pattern:"Solid"
                              }
                          }},
                    cells: {    
                          0:{
                              0:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid",
                                          },
                                  Alignment:{
                                    Horizontal:"Center",
                                    Vertical:"Center",
                                    WrapText: 1,
                                      },  
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                                  },                        
                                  }  
                              },
                              1:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                              },  
                                  Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },            
                                      }
                              },
                              2:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          }, 
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              }                
                                      }
                                  },
                              3:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1,
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                        
                                      }
                                  },
                              4:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  },
                              5:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  }, 
                              6:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                             
                                  }
                                  }, 
                                  7:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1, 
                                      },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },                             
                                      }
                                      },
                          }   
                    },
              };
              this.showExportButton = true;
              alasql.promise('SELECT * INTO XLSXML("Compras'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
              .then(function(data){
                  console.log('Data saved');
              }).catch(function(err){
                  console.log('Error:', err);
              });
            });
          });
    }

}



// WEBPACK FOOTER //
// ./src/app/reports/components/list-purchases/list-purchases.component.ts